module.exports = __webpack_public_path__ + "img/man-presenting-sm.efe98cb2.png";